import React, { useEffect } from "react";
import styled from "styled-components";
import { useDashboardStore } from "../store/useStore";

const DashboardContainer = styled.div`
  padding: 40px;
  background: linear-gradient(135deg, #ffffff 0%, #fff8f2 100%);
  min-height: 100vh;
`;

const StatsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 32px;
  margin-top: 60px;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
`;

const StatCard = styled.div`
  background: linear-gradient(135deg, #ffffff 0%, #fff8f2 100%);
  border: 1px solid #f0f0f0;
  border-radius: 20px;
  padding: 36px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 180px;
  box-shadow: 0 6px 20px rgba(210, 105, 30, 0.08);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #d2691e 0%, #b85a1a 100%);
  }

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 12px 40px rgba(210, 105, 30, 0.15);
  }
`;

const StatLabel = styled.h3`
  font-family: "Pretendard", sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: #6b6b6b;
  margin: 0 0 20px 0;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

const StatValue = styled.div`
  font-family: "Pretendard", sans-serif;
  font-weight: 700;
  font-size: 36px;
  color: #d2691e;
  text-align: left;
  line-height: 1.1;
  text-shadow: 0 2px 4px rgba(210, 105, 30, 0.1);
`;

const LoadingSpinner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  font-size: 18px;
  color: #d2691e;
`;

const ErrorMessage = styled.div`
  background: #fee;
  color: #d00;
  padding: 16px 20px;
  border-radius: 12px;
  margin-bottom: 30px;
  border: 1px solid #fcc;
  text-align: center;
`;

const RefreshButton = styled.button`
  background: linear-gradient(135deg, #d2691e 0%, #b85a1a 100%);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  margin-left: 10px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.2s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(210, 105, 30, 0.4);
  }
`;

const Dashboard = () => {
  const { stats, isLoading, error, fetchUserStats, clearError } =
    useDashboardStore();

  // 페이지 로드 시 통계 데이터 조회
  useEffect(() => {
    fetchUserStats();
  }, [fetchUserStats]);

  const formatNumber = (num) => {
    return (num || 0).toLocaleString("ko-KR");
  };

  const handleRefresh = () => {
    fetchUserStats();
  };

  return (
    <DashboardContainer>
      {error && (
        <ErrorMessage>
          {error}
          <RefreshButton onClick={handleRefresh}>다시 시도</RefreshButton>
          <RefreshButton
            onClick={clearError}
            style={{
              background: "transparent",
              color: "#d00",
              border: "1px solid #fcc",
            }}
          >
            닫기
          </RefreshButton>
        </ErrorMessage>
      )}

      {isLoading ? (
        <LoadingSpinner>사용자 통계를 불러오는 중...</LoadingSpinner>
      ) : (
        <StatsContainer>
          <StatCard>
            <StatLabel>총 회원수</StatLabel>
            <StatValue>{formatNumber(stats.totalUsers)}명</StatValue>
          </StatCard>

          <StatCard>
            <StatLabel>금일 가입 회원수</StatLabel>
            <StatValue>+{formatNumber(stats.newUsersToday)}명</StatValue>
          </StatCard>

          <StatCard>
            <StatLabel>금일 탈퇴 회원수</StatLabel>
            <StatValue>-{formatNumber(stats.withdrawnUsersToday)}명</StatValue>
          </StatCard>
        </StatsContainer>
      )}
    </DashboardContainer>
  );
};

export default Dashboard;
